
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import simplify from "@turf/simplify";
import LayerBoundary		from "../classes/LayerBoundary";

const DrawPolygon = MapboxDraw.modes.draw_polygon;
const geojsonTypes = MapboxDraw.constants.geojsonTypes;
const cursors = MapboxDraw.constants.cursors;
const types = MapboxDraw.constants.types;
const updateActions = MapboxDraw.constants.updateActions;
const modes = MapboxDraw.constants.modes;
const events = MapboxDraw.constants.events;


const boundaryMode = Object.assign({}, DrawPolygon)

boundaryMode.onSetup = function(opts) {
	opts = opts || {};
	let line, currentVertexPosition = (opts.startCoordinate ? 1 : 0);
	
	this.onFinish = opts.onFinish;
	
	
	const json = {
		type: geojsonTypes.FEATURE,
		properties: {
			color: LayerBoundary.defaultColor
		},
		geometry: {
			type: geojsonTypes.POLYGON,
			coordinates: [[]]
		},
		id:'added_boundary'
	}
	
	const polygon = this.newFeature(json);

	this.addFeature(polygon);
	this.clearSelectedFeatures();
		
	// disable dragPan
	setTimeout(() => {
		if (!this.map || !this.map.dragPan) return;
		this.map.dragPan.disable();
	}, 0);

	this.updateUIClasses({ mouse: cursors.ADD });
	this.setActionableState({
		trash: true
	});
	if (opts.startCoordinate && Array.isArray(opts.startCoordinate)) {
		polygon.updateCoordinate('0.0', opts.startCoordinate[0], opts.startCoordinate[1]);
	}
	return {
		polygon,
		currentVertexPosition: currentVertexPosition
	};
};

boundaryMode.onDrag = boundaryMode.onTouchMove = function (state, e){
	state.dragMoving = true;
	this.updateUIClasses({ mouse: cursors.ADD });
	state.polygon.updateCoordinate(`0.${state.currentVertexPosition}`, e.lngLat.lng, e.lngLat.lat);
	state.currentVertexPosition++;
	state.polygon.updateCoordinate(`0.${state.currentVertexPosition}`, e.lngLat.lng, e.lngLat.lat);
}
boundaryMode.onMouseDown = function(state, e) {
  
};
boundaryMode.onMouseUp = function (state, e){
	if (state.dragMoving) {
		this.simplify(state.polygon);
		this.fireUpdate();
		this.changeMode(modes.SIMPLE_SELECT, { featureIds: [state.polygon.id] });
	}
}

boundaryMode.onTouchEnd = function(state, e) {
	this.onMouseUp(state, e)
}

boundaryMode.fireUpdate = function() {
	this.map.fire(events.UPDATE, {
		action: updateActions.MOVE,
		features: this.getSelected().map(f => f.toGeoJSON())
	});
};

boundaryMode.simplify = function(polygon) {
	const tolerance = 1 / Math.pow(1.05, 100 * this.map.getZoom()); // https://www.desmos.com/calculator/nolp0g6pwr
	simplify(polygon, {
		mutate: true,
		tolerance: tolerance,
		highQuality: true
	});
}

boundaryMode.onStop = function (state) {
	DrawPolygon.onStop.call(this, state)
	setTimeout(() => {
		if (!this.map || !this.map.dragPan)
			return;
		this.map.dragPan.enable();
		if(this.onFinish)
			this.onFinish();
	}, 0);
};
	
export default boundaryMode